module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg5NiAxNjBhNjQgNjQgMCAwIDEgNjQgNjR2NTc2YTY0IDY0IDAgMCAxLTY0IDY0SDEyOGE2NCA2NCAwIDAgMS02NC02NFYyMjRhNjQgNjQgMCAwIDEgNjQtNjRoNzY4eiBtMCA2NEgxMjh2MzU0bDE1My43LTE2Mi42YTMyIDMyIDAgMCAxIDQ0LjctMS43bDI1MS43IDIyOC4yIDEyMi41LTEwNy45YTMyIDMyIDAgMCAxIDQyLjYgMC4yTDg5NiA2NzJWMjI0eiBtLTE2MCA5NmE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDAgMSAwLTEyOHoiIGZpbGw9IiMwIiBwLWlkPSIzOTk3Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Image-filled.svg
// module id = 1Pt3
// module chunks = 73